import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import TransactionItemsDetail from "./TransactionItemsDetail";
import SubLotExpressTable from "./SubLotExpressTable";
import SerialNumberExpressTable from "./SerialNumberExpressTable";
import LocationForReceipt from "./LocationForReceipt";
import axios from "axios";
import { Button } from "devextreme-react/button";
import * as PermissionsConstants from "../../const/constants";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { useHistory } from "react-router-dom";
import { ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import Popup from 'devextreme-react/popup';
import ScrollView from "devextreme-react/scroll-view";
import TransactionOverview from "./TransactionOverview"
import DataGrid, {
  Column,
  Paging,
  Scrolling
} from "devextreme-react/data-grid";
import { getAppSettings, downloadReportFile } from "../../common/Utils";

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
const TransactionDetail = (props) => {
  const history = useHistory();
  var accessToken = props.oidc.user.access_token;
  const [trnsDtlState, setTrnsDtlState] = useState({
    loading: false,
    dialogToShowAttachment: false,
    allDocs: [],
  });
  const [searchPanelStatus, setSearchPanelStatus] = React.useState(getAppSettings()?.FiltersCollapsed? false : true);
  var transactionId = !props?.transRowid
    ? props.ReceiptReducer?.receipt?.[0]?.rowid
    : props?.transRowid || "";
  var receiptDetailInfo = props.ReceiptReducer?.receipt?.[0];
  const [detailRowid, setDetailRowid] = useState(null);
  const [printButtonDisabled, setPrintButtonDisabled] = useState(true);
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
    const [printInvoiceReportLoader, setPrintInvoiceReportLoader] = useState(false);

  const [transaction, setTransaction] = useState({
    shipperbolnumber: "",
    reference: "",
    container: "",
    transactionnumber: "",
    actualreceivedshippeddatetime: "",
    rShipper: "",
    rowid: "",
    status: "",
    transactiongroup: "",
    transactiontype: ""
  });

  const initialTotals = {
    items: 0.00,
    ordered: 0.00,
    netWeight: 0.00,
    actual: 0.00,
    grossWeight: 0.00,
    inventory: 0.00,
    amount: 0.00,
  };
  const [selectedTotals, setSelectedTotals] = useState(initialTotals);

  const changeTotals = useCallback(async () => {
    try {
      const headerId = transactionId;
      if (!headerId || headerId === "00000000-0000-0000-0000-000000000000") {
        setSelectedTotals(initialTotals);
        return;
      }
      const response = await axios.get(
        `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTotals}`,
        {
          params: { headerRowId: headerId },
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = response.data?.result || response.data;
      setSelectedTotals(result || initialTotals);
      if (result?.recordNumber != null && result.recordNumber !== undefined) {
        setTransaction((prev) => ({ ...prev, recordNumber: result.recordNumber }));
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    }
  }, [transaction?.rowid, transactionId, accessToken]);

  const redirectUrl = props?.GotoScreen === PermissionsConstants.HistoryScreen ? "/wm/history" : "/wm/transaction";

  useEffect(() => {
    if (!transactionId) {
      history.push(redirectUrl);
      return;
    }
    loadTransacton();
  }, []);
  const loadTransacton = async () => {
    const result = await axios.get(
      `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionsById}?id=${transactionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setTransaction(result.data);
    changeTotals();
    setPrintButtonDisabled(false);
  };

  const [value, setValue] = useState(0);
  const [lotRowid, setLotRowid] = useState("");
  const [serialNumbRowid, setSerialNumbRowid] = useState("");
  const [locRowid, setLocRowid] = useState("");
  const [detailrowid, setdetailrowid] = useState("");
  const [lotcode, setlotCode] = useState("");
  const [itemcode, setiItemCode] = useState("");
  const [itemrowid, setItemrowid] = useState("");
  const [subdetailrowid, setSubDetailRowid] = useState("");
  const [sublotrowid, setSublotrowid] = useState("");
  const handleTabs = (childData) => {
    setLotRowid("");
    setSerialNumbRowid("");
    setLocRowid("");
    setdetailrowid("");
    setSubDetailRowid("");
    setItemrowid("");
    setItemrowid("");
    setSublotrowid("");
    setlotCode("");
    setiItemCode("");

    if (childData.lotId) setLotRowid(childData.lotId);
    if (childData.serialNumbRowid)
      setSerialNumbRowid(childData.serialNumbRowid);
    if (childData.locRowId) setLocRowid(childData.locRowId);
    if (childData.detailrowid) setdetailrowid(childData.detailrowid);
    if (childData.subdetailrowid) setSubDetailRowid(childData.subdetailrowid);
    if (childData.itemrowid) setItemrowid(childData.itemrowid);
    if (childData.sublotrowid) setSublotrowid(childData.sublotrowid);

    if (childData.lotcode) setlotCode(childData.lotcode);
    if (childData.itemcode) setiItemCode(childData.itemcode);

    setDetailRowid(childData.id);
    setValue(childData.value);
  };
  const ReceiptDetailPanel = useCallback((props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && <div>{children}</div>}
      </div>
    );
  }, [value])
  const selectionChanged = useCallback(
    (e) => {
     setSearchPanelStatus((prevStatus) => !prevStatus);

    },
    [searchPanelStatus],
  );

  const getDocsbySourceId = async () => {
    const dataBase =
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "";
    const result = await axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.AttachmentManager.GetAttachedDocsBySourceID}?sourceID=${transactionId}&dbName=${dataBase}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setTrnsDtlState({
          ...trnsDtlState,
          loading: true,
          allDocs: res.data,
          dialogToShowAttachment: true,
        });
      })
      .catch((err) => {
        console.log(err, "Error in loading getDocsbySourceId");
      });
  };

  const getDocsPDFbySourceId = async (e) => {
    e.event.stopPropagation();
    const dataBase =
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "";
    setLoadIndicatorVisible(true);
    await axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.AttachmentManager.DownloadAttachedDocsByTransactionNumber}?sourceId=${transactionId}&dbName=${dataBase}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
          responseType: "blob"
        }
      )
      .then((res) => {
        setLoadIndicatorVisible(false);
        const link = document.createElement("a");
        link.target = "_blank";
        link.download = res.headers.filenmae;
        var blob = new Blob([res.data], { type: "application/pdf" });
        link.href = URL.createObjectURL(blob);
        link.click();
      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        console.log(err, "Error in loading getDocsPDFbySourceId");
      });
  };
  const printInvoiceReport = (e) => {
    e.event.stopPropagation();
    setPrintInvoiceReportLoader(true);
    var report = new Object();
    report.Key = "WMR0046";
    report.Name = "WMR0046";

    var whereInfo = new Object();
    whereInfo.FieldType = 1000; // default;
    whereInfo.FieldName = "ROWID";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "WMINVOICEHEADER.ROWID";
    whereInfo.From = "(SELECT TOP 1  WMTRANSACTIONCHARGE.R_INVOICEHEADER FROM WMTRANSACTIONCHARGE WITH (NOLOCK) JOIN WMTRANSACTIONHEADER WITH (NOLOCK) ON WMTRANSACTIONCHARGE.R_TRANSACTIONHEADER = WMTRANSACTIONHEADER.ROWID WHERE WMTRANSACTIONHEADER.ROWID = '" + transaction.rowid + " AND WMTRANSACTIONCHARGE.R_INVOICEHEADER IS NOT NULL')";
    whereInfo.To = "(SELECT TOP 1  WMTRANSACTIONCHARGE.R_INVOICEHEADER FROM WMTRANSACTIONCHARGE WITH (NOLOCK) JOIN WMTRANSACTIONHEADER WITH (NOLOCK) ON WMTRANSACTIONCHARGE.R_TRANSACTIONHEADER = WMTRANSACTIONHEADER.ROWID WHERE WMTRANSACTIONHEADER.ROWID = '" + transaction.rowid + " AND WMTRANSACTIONCHARGE.R_INVOICEHEADER IS NOT NULL')";
    report.FilterWhereInfoList = [];
    report.IgnoreFormat=true;
    report.FilterWhereInfoList.push(whereInfo);
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data != undefined
        ) {
          if (res.data.isSuccess) {
            // Returned so the print-invoice loader stays up until the file has downloaded.
            return downloadReportFile(res.data.fileName, accessToken);
          } else {
            alert(
              "Cannot generate report. Error:  " + res.data.errorMessage,
              "Error"
            );
          }
        } else {
          alert("Cannot generate report", "Error");
        }
      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        alert(err, "Error");
      }).finally(()=>setPrintInvoiceReportLoader(false));
  };
  const printbasedOnScreen = (e) => {
    e.event.stopPropagation();
    if (
      props?.GotoScreen &&
      props?.GotoScreen == PermissionsConstants.HistoryScreen) {
      handlePrintReportClick();
    }
    else {
      exportReport();
    }
  };
  const handlePrintReportClick = () => {
    const profile = props.oidc.user.profile;
    initializeReport(transaction, profile);
  };
  const initializeReport = (transaction, profile) => {
    const report = {
      Key: "WMR0044",
      Name: "WMR0044",
      FormatName: "Standard Abecas"
    };
    if (transaction.transactiontype == "S")
      handleReportFormat(profile, report, "WMHISTORYSHIPMENTREPORTNAME", "WMHISTORYSHIPMENTREPORTFORMAT", transaction.transactiontype);
    else if (transaction.transactiontype == "R")
      handleReportFormat(profile, report, "WMHISTORYRECEIPTREPORTNAME", "WMHISTORYRECEIPTREPORTFORMAT", transaction.transactiontype);
    else
      processReport(report);
  };
  const handleReportFormat = (profile, report, keyName, formatName, transactionType) => {
    setReportProperties(profile, report, keyName, formatName, transactionType);
    if (report.FormatName == "") {
      fetchReportFormat(report.Name)
        .then(formatName => {
          report.FormatName = formatName;
          processReport(report);
        });
    } else
      processReport(report);
  };
  const setReportProperties = (profile, report, keyName, formatName, transactionType) => {
    if (profile.hasOwnProperty(keyName)) {
      report.Key = profile[keyName];
      report.Name = profile[keyName];
    } else {
      if (transactionType == "S") {
        report.Key = "WMR0004";
        report.Name = "WMR0004";
      }
    }
    if (profile.hasOwnProperty(formatName))
      report.FormatName = profile[formatName];
    if (transactionType == "S" && report.Key == "WMR0004")
      report.IgnoreBOLReportSetting = true;
  };
  const fetchReportFormat = (reportName) => {
    return axios.get(
      `${window._env_.REACT_APP_APIS}/${data.reports.GetReport}?reportName=${reportName}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`
        }
      }
    )
      .then((res) => {
        if (res.data && res.data.formatName)
          return res.data.formatName;
      }).catch(err => {
        console.log(err, "Error getting report data");
        throw err;
      });
  };
  const processReport = (report) => {
    const whereInfo = {
      FieldType: 0, // ParameterTypeEnum.String;
      FieldName: "TRANSACTIONNUMBER",
      Operation: 3, // OperationEnum.Equal
      Origin: "WMTRANSACTIONHEADER.TRANSACTIONNUMBER",
      From: transaction.transactionnumber
    };
    report.FilterWhereInfoList = [whereInfo];
    setLoadIndicatorVisible(true);
    axios.post(
      `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
      report,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken
        }
      }
    )
      .then(res => {
        if (res.hasOwnProperty("data") && res.data != null && res.data !== undefined) {
          if (res.data.isSuccess) {
            // Returned so the loader stays up until the file has downloaded.
            return downloadReportFile(res.data.fileName, accessToken);
          } else
            alert("Cannot generate report. Error: " + res.data.errorMessage, "Error");
        } else
          alert("Cannot generate report", "Error");
      })
      .catch(err => {
        alert(err, "Error");
      })
      .finally(() => setLoadIndicatorVisible(false));
  };

  const downloadDocById = async (doc) => {
    const dataBase =
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "";
    const result = await axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.AttachmentManager.DownloadAttachedDocsByID}?Rowid=${doc.rowid}&dbName=${dataBase}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        var base64 = response.data.base64str;
        var type = response.data.contenttype;
        var filename = response.data.filename;
        fetch(`data:${type};base64,${base64}`).then((response) => {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setTrnsDtlState({
              ...trnsDtlState,
              loading: true,
              dialogToShowAttachment: true,
            });
          });
        });
      })
      .catch((err) => {
        console.log(err, "Error in loading downloadDocById");
      });
  };

  const exportReport = () => {
    var report = new Object();
    report.Key = "WMR0049";
    report.Name = "WMR0049";

    var whereInfo = new Object();
    whereInfo.FieldType = 0; //ParameterTypeEnum.String;
    whereInfo.FieldName = "TRANSACTIONNUMBER";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "WMTRANSACTIONHEADER.TRANSACTIONNUMBER";
    whereInfo.From = receiptDetailInfo.transactionnumber;
    whereInfo.To = receiptDetailInfo.transactionnumber;
    report.FilterWhereInfoList = [];
    report.FilterWhereInfoList.push(whereInfo);
    setLoadIndicatorVisible(true);
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data != undefined
        ) {
          if (res.data.isSuccess) {
            // Returned so the loader stays up until the file has downloaded.
            return downloadReportFile(res.data.fileName, accessToken);
          } else {
            alert(
              "Cannot generate report. Error:  " + res.data.errorMessage,
              "Error"
            );
          }
        } else {
          alert("Cannot generate report", "Error");
        }
      })
      .catch((err) => {
        alert(err, "Error");
      })
      .finally(() => setLoadIndicatorVisible(false));
  };
  const routeChange = (e) => {
    e.event.stopPropagation();
    props.resetQueryForm(null);
    props.transactionCallbackOnUnCheck(0);
    let path =
      props?.GotoScreen &&
        props?.GotoScreen == PermissionsConstants.HistoryScreen
        ? "/wm/history"
        : "/wm/transaction";
    history.push(path);
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            <AccordionReact
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={300}
              onSelectionChanged={selectionChanged}
              defaultSelectedIndex={getAppSettings()?.FiltersCollapsed ? -1 : 0}
              className={transaction.transactiontype == "S" && value !== 0 ? "trans-view-3-row-accordion-height" : "trans-view-2-row-accordion-height"}
              itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                        {value === 0
                          ? "Item Detail"
                          : value === 1
                            ? "Sub Lot Detail"
                            : value === 2
                              ? "Serial Number Detail"
                              : "Location Detail"}
                      </h6>
                    </div>
                  </Item>
                  <Item location="after">
                    <Button
                      className="accordianButton accordianButton-withicon"
                      type="default"
                      onClick={getDocsPDFbySourceId}
                    >
                      <i className="dx-icon-attach mr-1"></i>
                      <span className="dx-button-text btn-line-hight">External Attachment</span>
                    </Button>
                  </Item>
                  <Item location="after">
                    <Button
                      className="accordianButton accordianButton-withicon"
                      type="default"
                      onClick={(e) => {
                        e.event.stopPropagation();
                        setTrnsDtlState({
                          ...trnsDtlState,
                          dialogToShowAttachment: true,
                        });
                        getDocsbySourceId();
                      }}
                    >
                      <i className="dx-icon-attach mr-1"></i>
                      <span className="dx-button-text btn-line-hight">Attachment</span>
                    </Button>
                  </Item>
                  <Item location="after">
                    <Button
                      disabled={printButtonDisabled}
                      className="accordianButton accordianButton-withicon"
                      type="default"
                      onClick={printbasedOnScreen}
                    >
                      <LoadIndicator
                        className="load-indicator"
                        visible={loadIndicatorVisible}
                      />
                      <i className="dx-icon-print mr-1"></i>
                      <span className="dx-button-text btn-line-hight">
                         {(() => {
                            const isShipment = (transaction.transactiontype || receiptDetailInfo?.transactiontype) === "S";
                            const isHistory = props?.GotoScreen === PermissionsConstants.HistoryScreen;
                            if (isHistory && isShipment) return "BOL";
                            if (!isHistory && isShipment) return "Print Open Shipment Rpt";
                            return "Print";
                         })()}
                      </span>
                    </Button>
                  </Item>
                  {
                    props?.GotoScreen &&
                    props?.GotoScreen == PermissionsConstants.HistoryScreen && (
                      <Item location="after">
                        <Button
                          disabled={printInvoiceReportLoader || printButtonDisabled}
                          className="accordianButton accordianButton-withicon"
                          type="default"
                          onClick={printInvoiceReport}
                        >
                          <LoadIndicator
                            className="load-indicator"
                            visible={printInvoiceReportLoader}
                          />
                          <i className="dx-icon-print mr-1"></i>
                          <span className="dx-button-text btn-line-hight">Print Invoice</span>
                        </Button>
                      </Item>
                    )
                  }
                  <Item location="after">
                    <Button className="accordianButton accordianButton-withicon" onClick={routeChange}>
                      <i className="dx-icon-back"></i>
                      <span className="dx-button-text btn-line-hight">Back to List</span>
                    </Button>
                  </Item>
                  {
                    (value == 1 || value == 2 || value == 2) &&
                    <Item location="after">
                      <Button
                        className="accordianButton accordianButton-withicon"
                        onClick={(e) => {
                          e.event.stopPropagation();
                          const request = {
                            value: 0,
                            id: transactionId,
                          };
                          handleTabs(request);
                        }}>
                        <i className="dx-icon-back"></i>
                        <span className="dx-button-text btn-line-hight">Back</span>
                      </Button>
                    </Item>
                  }
                </Toolbar>
              )}
              itemRender={(itemProps) => (
                <div>
                  <ReceiptDetailPanel value={value} index={0}>
                    <TransactionOverview
                      transaction={transaction}
                      profile={props.oidc.user.profile}
                      ABECASUSER_LOGIN_TYPE={ABECASUSER_LOGIN_TYPE}
                      selectedTotals={selectedTotals}
                    />
                  </ReceiptDetailPanel>
                  {[1, 2, 3].map((index) => (
                    <ReceiptDetailPanel key={index} value={value} index={index}>
                      <TransactionOverview
                        transaction={transaction}
                        profile={props.oidc.user.profile}
                        ABECASUSER_LOGIN_TYPE={ABECASUSER_LOGIN_TYPE}
                        itemcode={itemcode}
                        lotcode={lotcode}
                        selectedTotals={selectedTotals}
                      />
                    </ReceiptDetailPanel>
                  ))}
                </div>
              )}
              id="accordion-container"
            />
          </div>
          <div>
            <ReceiptDetailPanel value={value} index={0}>
              <TransactionItemsDetail
                changeTab={(e) => handleTabs(e)}
                id={transactionId}
                SearchPanelAccordionStatus={searchPanelStatus}
                isTransItmsOnly={
                  props?.isTransItmsOnly ? props.isTransItmsOnly : false
                }
              />
            </ReceiptDetailPanel>
            <ReceiptDetailPanel value={value} index={1}>
              <SubLotExpressTable
                changeTab={handleTabs}
                lotid={lotRowid}
                id={transactionId}
                SearchPanelAccordionStatus={searchPanelStatus}
              />
            </ReceiptDetailPanel>
            <ReceiptDetailPanel value={value} index={2}>
              <SerialNumberExpressTable
                id={transactionId}
                detailrowid={detailrowid}
                subdetailrowid={subdetailrowid}
                itemrowid={itemrowid}
                lotRowid={lotRowid}
                sublotrowid={sublotrowid}
                changeTab={(e) => handleTabs(e)}
                SearchPanelAccordionStatus={searchPanelStatus}
              />
            </ReceiptDetailPanel>
            <ReceiptDetailPanel value={value} index={3}>
              <LocationForReceipt
                changeTab={handleTabs}
                lotid={lotRowid}
                id={transactionId}
                SearchPanelAccordionStatus={searchPanelStatus}
              />
            </ReceiptDetailPanel>
          </div>
        </div>
      </div>
      {trnsDtlState.dialogToShowAttachment &&
        <Popup
          visible={trnsDtlState.dialogToShowAttachment}
          onHiding={() =>
            setTrnsDtlState({
              ...trnsDtlState,
              dialogToShowAttachment: false,
            })
          }
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Attachment"
          container="#root"
          closeOnOutsideClick={true}
          height={600}
          width={600}
        >
          <ScrollView width="100%" height="100%">
            <div className="row">
              <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                dataSource={trnsDtlState.allDocs}
                showBorders={true}
                keyExpr="rowid"
                columnAutoWidth={true}
                noDataText="No Data"
              >
                <Scrolling mode="virtual" />
                <Paging enabled={false} />

                <Column dataField="filename" caption="Doc Name" width={300} />
                <Column dataField="comment" caption="Comment" />
                <Column
                  caption="Action"
                  cellRender={(cellData) => (
                    <Button
                      icon="download"
                      onClick={() => downloadDocById(cellData.data)}
                      stylingMode="contained"
                    />
                  )}
                />
              </DataGrid>
            </div>
          </ScrollView>
        </Popup>}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionDetail);
